import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1395a2d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_wrap mod_set_wrap select_none" }
const _hoisted_2 = { class: "mod_c_title watch_title" }
const _hoisted_3 = { style: {"margin-left":"20px","margin-top":"-6px"} }
const _hoisted_4 = { class: "mod_c_tbody" }
const _hoisted_5 = { class: "mod_content" }
const _hoisted_6 = { class: "posterBox" }
const _hoisted_7 = { class: "img_list_box" }
const _hoisted_8 = { class: "headimg_img_pc mark_wrap" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  class: "pc_mark"
}
const _hoisted_11 = { class: "pc_mark_btn" }
const _hoisted_12 = { class: "img_item_wrap" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "建议尺寸1920*1080小于2M", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "(支持JPG、GIF、PNG、BMP)", -1))
const _hoisted_15 = { class: "pcBox" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "pc背景图", -1))
const _hoisted_17 = { class: "pcUpload" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "建议尺寸1920*1080小于2M", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "(支持JPG、GIF、PNG、BMP)", -1))
const _hoisted_20 = { class: "bg_color" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "背景色", -1))
const _hoisted_22 = { class: "color_install" }
const _hoisted_23 = { class: "color_install_pattern" }
const _hoisted_24 = { class: "pattern_common" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "color_install_pattern color_install_patterns" }
const _hoisted_27 = { class: "pattern_name" }
const _hoisted_28 = { class: "channer_backselect" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "theme_title" }, "背景颜色：", -1))
const _hoisted_30 = { class: "mod_save" }

import { ref, reactive } from 'vue';
import { useRoute } from 'vue-router';
import router from '@/router';
import http from '@/api/playback';
import { getToken } from '@/plugins/cookie';
import { message } from 'ant-design-vue';
import { ElColorPicker } from 'element-plus';
import CRumb from '@/components/Crumb.vue';
import CUpload from '@/components/CUpload.vue';
import { DeleteOutlined } from '@ant-design/icons-vue';
import { useDebounce } from '@/hooks/useDebounce';

interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  type?: string;
  size: number;
  originFileObj: never;
}
interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}
interface idtype {
  id: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'StreamBoot',
  setup(__props) {

const route = useRoute();
const token = getToken();
const studioId = router.currentRoute.value.params.studioId;
//颜色选择器
const colorList = ref(['#00CCB0', '#1890FF', '#FF4D4F', '#FF9337']);
const color = ref(colorList.value[0]);
// 选择频道配色
const getColor = (colors: any) => {
  color.value = colors;
};
// 重置
const reset = () => {
  color.value = colorList.value[0];
  color.value = '#F5F5F5';
};
//开关的按钮
const switchstatus = ref<any>(false);
//查询直播间信息
const stream_style_show = () => {
  let data = {
    token: token,
    studio_id: studioId,
  };
  http.stream_style_show({ params: data }).then((res) => {
    res.data.data.relation_guide == 1 ? (switchstatus.value = true) : (switchstatus.value = false);
    color.value = res.data.data.pc_bg_color;
    imageUrlel.value = res.data.data.pc_bg_img_url;
    upload_img_list.value = res.data.data.cover_pic_urls;
    img_id_list.value = res.data.data.cover_pic_ids.split(',');
    pcImgId.value = res.data.data.pc_bg_img_id;
  });
};
stream_style_show();
//pc背景图
const imageUrlel = ref<string>('');
//活动海报的数组
const upload_img_list = ref<string[]>([]);
const fileList = ref([]);
const loading = reactive({
  headImg: false,
  headImgM: false,
});
const getBase64 = (img: Blob, callback: (base64Url: string) => void) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result as string));
  reader.readAsDataURL(img);
};
const clearImg = (keyword: string) => {
  switch (keyword) {
    case 'headImg':
      break;
    case 'headImgM':
      pcImgId.value = '';
      imageUrlel.value = '';
      break;
  }
};
const pcImgId = ref<string>(); //pc背景图id
const img_id_list = ref<idtype[]>([]); //活动海报id数组
const handleChange = (info: FileInfo, keyword: string): void => {
  if (info.file.status === 'uploading') {
    loading[keyword] = true;
    return;
  }
  if (info.file.status === 'done') {
    getBase64(info.file.originFileObj, () => {
      if (info.file?.response?.code === 200) {
        switch (keyword) {
          case 'headImg':
            upload_img_list.value.push(info.file?.response?.data.url);
            img_id_list.value?.push(info.file?.response?.data.id);
            break;
          case 'headImgM':
            imageUrlel.value = info.file?.response?.data.url;
            pcImgId.value = info.file?.response?.data.id;
            break;
        }
      } else {
        message.error(info.file?.response?.error);
      }
      loading[keyword] = false;
    });
  }
  if (info.file.status === 'error') {
    loading[keyword] = false;

    message.error('上传失败');
  }
};
//删除图片
const onRemoveImg = (index: number) => {
  upload_img_list.value.splice(index, 1);
  img_id_list.value.splice(index, 1);
};
//保存
const backSave = useDebounce((subType = '') => {
  let data = {
    cover_pic_ids: img_id_list.value.toString(),
    pc_bg_color: color.value,
    pc_bg_img_id: pcImgId.value, //pc背景图id
    relation_guide: switchstatus.value == true ? 1 : 0,
    studio_id: studioId,
  };
  // 开关调取接口
  if (subType) {
    data.relation_guide = switchstatus.value == true ? 0 : 1;
  }
  http
    .stream_style_set(data)
    .then((res) => {
      message.destroy();
      subType && (switchstatus.value = !switchstatus.value);
      message.success(res.data.message);
    })
    .catch((err) => {
      message.error(err.data.message);
    });
});

return (_ctx: any,_cache: any) => {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_P = _resolveComponent("P")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CRumb),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_unref(route).meta?.title), 1),
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_a_switch, {
            checked: switchstatus.value,
            onChange: _cache[0] || (_cache[0] = ($event: any) => (_unref(backSave)('switch')))
          }, null, 8, ["checked"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_P, { class: "title" }, {
              default: _withCtx(() => [
                _createTextVNode("活动海报")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(upload_img_list.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "img_item_wrap"
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: item,
                      class: "pc_img",
                      alt: "avatar"
                    }, null, 8, _hoisted_9),
                    item
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_unref(DeleteOutlined), {
                              class: "CIons",
                              onClick: _withModifiers(($event: any) => (onRemoveImg(index)), ["stop"])
                            }, null, 8, ["onClick"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(CUpload, {
                  "file-list": fileList.value,
                  "handle-change": (info) => handleChange(info, 'headImg'),
                  loading: loading.headImg,
                  class: "ant_upload"
                }, {
                  uploadImg: _withCtx(() => [
                    _hoisted_13,
                    _hoisted_14
                  ]),
                  _: 1
                }, 8, ["file-list", "handle-change", "loading"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createVNode(CUpload, {
                "file-list": fileList.value,
                "handle-change": (info) => handleChange(info, 'headImgM'),
                loading: loading.headImgM,
                "image-name": imageUrlel.value,
                "click-stop": (info) => clearImg('headImgM'),
                class: "ant_upload"
              }, {
                uploadImg: _withCtx(() => [
                  _hoisted_18,
                  _hoisted_19
                ]),
                _: 1
              }, 8, ["file-list", "handle-change", "loading", "image-name", "click-stop"])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colorList.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item,
                      class: "pattern_common_color",
                      style: _normalizeStyle({ background: item }),
                      onClick: ($event: any) => (getColor(item))
                    }, null, 12, _hoisted_25))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, _toDisplayString(color.value), 1),
                _createVNode(_unref(ElColorPicker), {
                  modelValue: color.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((color).value = $event)),
                  predefine: colorList.value,
                  size: "mini"
                }, null, 8, ["modelValue", "predefine"])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createVNode(_unref(ElColorPicker), {
                  modelValue: color.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((color).value = $event)),
                  predefine: colorList.value,
                  size: "mini"
                }, null, 8, ["modelValue", "predefine"])
              ]),
              _createElementVNode("div", { class: "footer_button" }, [
                _createElementVNode("button", {
                  class: "btn_reset",
                  onClick: reset
                }, "重置")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_a_button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(backSave)()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})